import { render, staticRenderFns } from "./BannerGridItem.vue?vue&type=template&id=98bfc9f2"
import script from "./BannerGridItem.vue?vue&type=script&lang=js"
export * from "./BannerGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports